module.exports = __webpack_public_path__ + "img/barcode.d2dc94b5.png";